import { Dropdown, Flex, Typography } from 'antd';
import React from 'react';
import { Link } from "react-router-dom";
import { ROUTES } from 'shared/const/routes';
import { CiGlobe } from "react-icons/ci";
import classes from './AuthHeader.module.scss';
import { useDispatch } from 'react-redux';
import { AVAILABLE_LANGUAGES, Language } from 'shared/const/languages';
import { setLanguage } from 'shared/config/store/reducers/appSlice';
import { GlobalOutlined } from '@ant-design/icons';

const AuthHeader: React.FC = () => {
  const dispatch = useDispatch();

  const onSetLocale = (locale: Language) => {
    dispatch(setLanguage(locale));
  };

  return (
    <div className={classes.authHeaderContainer}>
      <Link to={ROUTES.LOGIN.path}>
        <div className={classes.authHeaderTitleContainer}>
          <Typography.Text className={classes.authHeaderTitle}>{'Weststein'}</Typography.Text>
        </div>
      </Link>
      <Dropdown
        trigger={['click']}
        placement='bottom'
        menu={{
          items: Object.values(AVAILABLE_LANGUAGES).map((l) => ({
            key: l.id,
            label: (
              <Flex gap={6} align='center' onClick={() => onSetLocale(l.id)}>
                <span style={{ borderRadius: 3, fontSize: 14 }} className={`fi fi-${l.flagId}`} />
                <Typography.Text>{l.id.toUpperCase()}</Typography.Text>
              </Flex>
            )
          }))
        }}
      ><GlobalOutlined id='btn__lang-switcher' style={{ cursor: 'pointer' }} size={24} /></Dropdown>
    </div>
  );
};

export default AuthHeader;